module.exports = __webpack_public_path__ + "assets/img/extractionTarot_Tit.8f651959.png";